import { useQuery } from '@tanstack/react-query';

import { PricingPlanTier } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-tier/:tierId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    planId: string;
    tierId: string;
    parkingId: string;
}
const queryFn = ({ planId, tierId, parkingId }: DTO): Promise<PricingPlanTier> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, tierId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPricingPlanTier };
